// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__iGIZ9","value":"styles_value__3PCz2"};